
<div class="container">
  <div class="row mt-3">
    <div class="col-md-2">&nbsp;</div>
    <div class="col-md-8">
      <h5>User:</h5>
      <error [error]="error"></error>
      <form #projectForm="ngForm" (ngSubmit)="save()">
        <div class="card-block">
          <div class="form-group">
            <label class="required" for="uid">Employee Email</label>
            <div class="input-group">
              <input class="form-control" id="uid" [(ngModel)]="user.uid" type="email" name="uid" required="true" pattern="[a-zA-Z0-9_.]+@(.*\.){0,1}(hp\.com|HP\.COM)" maxlength="60"><span class="input-group-append" *ngIf="!user.id">
                <button class="btn btn-primary" (click)="autofill();$event.preventDefault()" [disabled]="!user.uid">Auto-fill</button></span>
            </div>
          </div>
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" name="useAlternateEmail" [(ngModel)]="alternateEmail" autoLinkToLabel>
              <label class="form-check-label">Use Alternate Email Address</label>
            </div>
          </div>
          <div class="form-group" *ngIf="alternateEmail">
            <label class="required" for="emailAddress">Alternate Email Address</label>
            <input class="form-control" id="emailAddress" [(ngModel)]="user.emailAddress" type="email" name="emailAddress" [required]="alternateEmail" pattern="[a-zA-Z0-9_.]+@(.*\.){0,1}(hp\.com|HP\.COM)" maxlength="60">
          </div>
          <div class="form-group">
            <label class="required" for="firstName">First Name</label>
            <input class="form-control" id="firstName" type="text" [(ngModel)]="user.firstName" name="firstName" required="true" pattern="['a-zA-ZÀ-ſ ]{1,30}" maxlength="30">
          </div>
          <div class="form-group">
            <label class="required" for="lastName">Last Name</label>
            <input class="form-control" id="lastName" type="text" [(ngModel)]="user.lastName" name="lastName" required="true" pattern="['a-zA-ZÀ-ſ ]{1,30}" maxlength="30">
          </div>
          <div class="form-group">
            <label>Roles</label>
            <select class="form-control" [(ngModel)]="rolesSelected" name="rolesSelected" multiple>
              <option *ngFor="let role of roles" [ngValue]="role.id">{{ role.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Managers</label>
            <textarea class="form-control" [(ngModel)]="managers" name="managers" [disabled]="!isManager"></textarea>
          </div>
          <div class="form-group">
            <div class="btn-group float-right"><a class="btn btn-outline-secondary ml-1" [href]="'/#/users'">Cancel</a>
              <button class="btn btn-primary" type="submit">Save</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>